import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=d2f2f44c&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens-v2.vue?vue&type=style&index=0&id=d2f2f44c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2f2f44c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d2f2f44c')) {
      api.createRecord('d2f2f44c', component.options)
    } else {
      api.reload('d2f2f44c', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=d2f2f44c&scoped=true&", function () {
      api.rerender('d2f2f44c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22M0Ip99fHjKm/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports